import type { UserInfo } from '@/interfaces/users';
import { authService } from '@/services/auth';
import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useAuthStore = defineStore('auth', () => {

    const user = ref<UserInfo>();
    const token = ref("");
    const remember = ref<boolean>(localStorage.getItem('remember') === 'true');

    watch(remember, (value) => {
        localStorage.setItem('remember', value.toString());
    }, {
        immediate: true
    })

    const loadUser = async () => {
        if (!user.value) {
            const data = await authService.userInfo();
            user.value = data;
        }
        return user.value;
    };

    const reloadUser = async () => {
        const data = await authService.userInfo();
        user.value = data;
        return user.value;
    };

    const refreshToken = async () => {
        token.value = await authService.refreshToken();
    }

    const login = async () => {
        localStorage.setItem("login", Date.now().toString());
    }

    const logout = async () => {
        localStorage.setItem("logout", Date.now().toString());
        await doLogout();
    }

    const doLogout = async () => {
        await authService.logout();
        window.location.href = "/login"
    }

    const init = async () => {

        window.addEventListener("storage", (event) => {
            // Ao logar de uma aba, desloga de todas as outras abas
            if (event.key === "logout") {
                doLogout();
            }
            // Recarrega a página das abas abertas para logar
            if (event.key === "login") {
                window.location.reload()
            }

        });


    }

    const hasPermission = (name: string) => {
        return user.value?.permissions.includes(name)
    }

    return {
        user,
        token,
        remember,
        refreshToken,
        login,
        logout,
        init,
        loadUser,
        reloadUser,
        hasPermission
    }

});